class Invitation {
  constructor(data) {
    this._id = data._id || data.objectID || data.id;
    this.email = data.email;
    this.role = data.role || "user";
    this.status = data.status || "pending";
  }
}
export default Invitation;
